// extracted by mini-css-extract-plugin
module.exports = {"gridView":"styles_gridView__eZzsZ","listView":"styles_listView__56lIR"};